import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import CompanyDetail from './pages/CompanyDetail';
import PersonalCategory from './pages/PersonalCategory';
import LegalPage from './pages/LegalPage';
import Profile from './pages/Profile';
import PaymentInfrastructure from './pages/PaymentInfrastructure';
import BudgetManagement from './pages/BudgetManagement';
import ContentCalendar from './pages/ContentCalendar';
import WeeklyBriefing from './pages/WeeklyBriefing';
import FinancialDashboard from './pages/FinancialDashboard';
import EmailHub from './pages/EmailHub';
import LandingPage from './pages/LandingPage';
import VisionPage from './pages/VisionPage';
import AdvisoryPage from './pages/AdvisoryPage';
import CollaborationsPage from './pages/CollaborationsPage';
import BIDashboard from './pages/BIDashboard';
import OpportunitiesPage from './pages/OpportunitiesPage';
import AnnualPlanner from './pages/AnnualPlanner';
import UnifiedPlanner from './pages/UnifiedPlanner';
import ShoppingList from './pages/ShoppingList';
import CeoDashboard from './pages/CeoDashboard';
import Navigator from './pages/Navigator';
import NavigatorCRM from './pages/NavigatorCRM';
import HmrcDashboard from './pages/hmrc/HmrcDashboard';
import HmrcCompanies from './pages/hmrc/HmrcCompanies';
import HmrcCompanyDetail from './pages/hmrc/HmrcCompanyDetail';
import HmrcChat from './pages/hmrc/HmrcChat';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/vision" element={<VisionPage />} />
          <Route path="/advisory" element={<AdvisoryPage />} />
          <Route path="/collaborations" element={<CollaborationsPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/legal/:type" element={<LegalPage />} />

          {/* Protected routes — require authentication */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/company/:id" element={<ProtectedRoute><CompanyDetail /></ProtectedRoute>} />
          <Route path="/personal/:category" element={<ProtectedRoute><PersonalCategory /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/infrastructure" element={<ProtectedRoute><PaymentInfrastructure /></ProtectedRoute>} />
          <Route path="/budget" element={<ProtectedRoute><BudgetManagement /></ProtectedRoute>} />
          <Route path="/content-calendar" element={<ProtectedRoute><ContentCalendar /></ProtectedRoute>} />
          <Route path="/weekly-briefing" element={<ProtectedRoute><WeeklyBriefing /></ProtectedRoute>} />
          <Route path="/financial-dashboard" element={<ProtectedRoute><FinancialDashboard /></ProtectedRoute>} />
          <Route path="/email" element={<ProtectedRoute><EmailHub /></ProtectedRoute>} />
          <Route path="/bi-dashboard" element={<ProtectedRoute><BIDashboard /></ProtectedRoute>} />
          <Route path="/opportunities" element={<ProtectedRoute><OpportunitiesPage /></ProtectedRoute>} />
          <Route path="/annual-planner" element={<ProtectedRoute><AnnualPlanner /></ProtectedRoute>} />
          <Route path="/planner" element={<ProtectedRoute><UnifiedPlanner /></ProtectedRoute>} />
          <Route path="/shopping" element={<ProtectedRoute><ShoppingList /></ProtectedRoute>} />
          <Route path="/ceo" element={<ProtectedRoute><CeoDashboard /></ProtectedRoute>} />
          <Route path="/navigator" element={<ProtectedRoute><Navigator /></ProtectedRoute>} />
          <Route path="/navigator/crm" element={<ProtectedRoute><NavigatorCRM /></ProtectedRoute>} />

          {/* HMRC Control */}
          <Route path="/hmrc" element={<ProtectedRoute><HmrcDashboard /></ProtectedRoute>} />
          <Route path="/hmrc/companies" element={<ProtectedRoute><HmrcCompanies /></ProtectedRoute>} />
          <Route path="/hmrc/companies/:id" element={<ProtectedRoute><HmrcCompanyDetail /></ProtectedRoute>} />
          <Route path="/hmrc/chat" element={<ProtectedRoute><HmrcChat /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
